import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { BlankIcon, SuccessIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
const TaskGroupCheckbox = ({
  isChecked
}) => {
  return isChecked ? /*#__PURE__*/_jsx(IconHolder, {
    backgroundColor: "fill-positive-default",
    borderRadius: "300",
    borderWidth: "0",
    color: "text-positive-on-fill-default",
    icon: SuccessIcon,
    size: "300"
  }) : /*#__PURE__*/_jsx(IconHolder, {
    borderColor: "border-core-subtle",
    borderRadius: "300",
    borderWidth: "200",
    icon: BlankIcon,
    size: "200"
  });
};
export default TaskGroupCheckbox;